import { RemoteEntityStore } from '@softline/core';
import { Customer } from './data/customer';

export const SOFTLINE_FEATURE_CUSTOMER_QUERY = 'customerQuery';

export const SOFTLINE_PERMISSION_CUSTOMER_QUERY = 'KUNDENABFRAGE';

export const SelectedCustomerStore = RemoteEntityStore.create<Customer>();
